<template>
    <div style="margin: 40px;">
      <el-form label-width="120px" label-position="left">
        <el-col :span="12">
          <el-form-item label="广告选择:">
            <el-select v-model="gginfo" filterable clearable placeholder="请选择广告" @change="selectgg">
              <el-option
                v-for="item in gglist"
                :key="item.APP_ID"
                :label="item.APP_NAME"
                :value="item.APP_ID"
              >
                <span style="float: left">{{ item.APP_NAME }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.APP_ID }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="渠道选择:">
            <el-select v-model="qdinfo" filterable clearable placeholder="请选择渠道">
              <el-option
                v-for="item in qdlist"
                :key="item.COMPANY_KEY"
                :label="item.NAME"
                :value="item.COMPANY_KEY"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="广告主链接:">
            <el-input v-model="ggzurl" placeholder="请输入广告主链接"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="IDFA:">
            <el-input v-model="idfa" placeholder="请输入IDFA"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="CAID:">
            <el-input v-model="caid" placeholder="请输入CAID"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="IP:" >
            <el-input v-model="ip" placeholder="请输入IP"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="OAID:" >
            <el-input v-model="oaid" placeholder="安卓设备必填"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="UA:" >
            <el-input v-model="ua" placeholder="非必填"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="TS:" >
            <el-input v-model="ts" placeholder="非必填">
              <el-button slot="append" @click="getts" icon="el-icon-search"></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="CallBack:" >
            <el-input v-model="callback" placeholder="必填">
              <el-button slot="append" @click="getcb" icon="el-icon-search"></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div>{{tmpcallbackurl}}</div>
      <div>{{tmpurl}}</div>
      <el-button style="margin-top: 20px" @click="showurl">显示链接</el-button>
      <el-button style="margin-top: 20px" @click="testurl">测试链接</el-button>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import Utils from '../../util/utils'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'NewTest',
    data () {
      return {
        ggzurl: '',
        idfa: '',
        ip: '',
        ts: '',
        oaid: '',
        ua: '',
        gglist: [],
        gginfo: '',
        qdlist: [],
        qdinfo: '',
        callback: '',
        caid: '',
        tmpurl: '',
        tmpcallbackurl: ''
      }
    },
    mounted: function () {
      that = this
      that.ua = navigator.userAgent
      that.$options.methods.querygg()
      that.$options.methods.queryqd()
    },
    methods: {
      getcb () {
        var tmpurlstr = 'http://api.jiyuewuxian.cn/allcallback?idfa=' + that.idfa + '&ip=' + that.ip + '&caid=' + that.caid + '&pid=' + that.gginfo + '&cid=' + that.qdinfo + '&callback='
        this.tmpcallbackurl = tmpurlstr
        this.callback = encodeURIComponent(tmpurlstr)
      },
      querygg () {
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getads',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.status === 200) {
              that.gglist = res.data
            } else {
              that.gglist = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      queryqd () {
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getchannels',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.status === 200) {
              that.qdlist = res.data
            } else {
              that.qdlist = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      addclick () {},
      getts () {
        this.ts = new Date().getTime();
      },
      showurl () {
        var tmpurl = that.ggzurl
        let reg1= new RegExp('{idfa}','g')
        let reg2= new RegExp('{ip}','g')
        let reg3= new RegExp('{ts}','g')
        let reg4= new RegExp('{oaid}','g')
        let reg5= new RegExp('{ua}','g')
        let reg6= new RegExp('{callback}','g')
        let reg7= new RegExp('{caid}','g')
        // 测试链接
        if (that.idfa !== '') {
          tmpurl = tmpurl.replace(reg1,that.idfa)
        } else {
          tmpurl = tmpurl.replace(reg1,'')
        }
        if (that.ip !== '') {
          tmpurl = tmpurl.replace(reg2,that.ip)
        } else {
          tmpurl = tmpurl.replace(reg2,'')
        }
        if (that.ts !== '') {
          tmpurl = tmpurl.replace(reg3,that.ts)
        } else {
          tmpurl = tmpurl.replace(reg3,'')
        }
        if (that.oaid !== '') {
          tmpurl = tmpurl.replace(reg4,that.oaid)
        } else {
          tmpurl = tmpurl.replace(reg4,'')
        }
        tmpurl = tmpurl.replace(reg5,that.ua)
        if (that.callback !== '') {
          tmpurl = tmpurl.replace(reg6,that.callback)
        } else {
          tmpurl = tmpurl.replace(reg6,'')
        }
        if (that.caid !== '') {
          tmpurl = tmpurl.replace(reg7,that.caid)
        } else {
          tmpurl = tmpurl.replace(reg7,'')
        }
        window.console.log(tmpurl)
        that.tmpurl = tmpurl
      },
      testurl () {
        var tmpurl = that.ggzurl
        let reg1= new RegExp('{idfa}','g')
        let reg2= new RegExp('{ip}','g')
        let reg3= new RegExp('{ts}','g')
        let reg4= new RegExp('{oaid}','g')
        let reg5= new RegExp('{ua}','g')
        let reg6= new RegExp('{callback}','g')
        let reg7= new RegExp('{caid}','g')
        // 测试链接
        if (that.idfa !== '') {
          tmpurl = tmpurl.replace(reg1,that.idfa)
        } else {
          tmpurl = tmpurl.replace(reg1,'')
        }
        if (that.ip !== '') {
          tmpurl = tmpurl.replace(reg2,that.ip)
        } else {
          tmpurl = tmpurl.replace(reg2,'')
        }
        if (that.ts !== '') {
          tmpurl = tmpurl.replace(reg3,that.ts)
        } else {
          tmpurl = tmpurl.replace(reg3,'')
        }
        if (that.oaid !== '') {
          tmpurl = tmpurl.replace(reg4,that.oaid)
        } else {
          tmpurl = tmpurl.replace(reg4,'')
        }
        tmpurl = tmpurl.replace(reg5,that.ua)
        if (that.callback !== '') {
          tmpurl = tmpurl.replace(reg6,that.callback)
        } else {
          tmpurl = tmpurl.replace(reg6,'')
        }
        if (that.caid !== '') {
          tmpurl = tmpurl.replace(reg7,that.caid)
        } else {
          tmpurl = tmpurl.replace(reg7,'')
        }
        window.console.log(tmpurl)
        let nowStr2 = Utils.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss') // 当前时间
        var qdata1 = {
          idfa: that.idfa,
          pid: that.gginfo,
          ip: that.ip,
          cid: that.qdinfo,
          caid: that.caid,
          callback: that.tmpcallbackurl,
          adddate: nowStr2,
          url: tmpurl
        }
        that.$http({
          url: 'http://api.jiyuewuxian.cn/sendclick',
          method: 'post',
          data: qdata1,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.data.result === 'success') {
              that.$message(res.data.data);
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/gg/NewTest.vue